import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/es';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'fr'],
    ns: ['common', 'booking', 'validation', 'forms'],
    defaultNS: 'common',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
    detection: {
      // Order of language detection
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Do not auto-cache; language is stored explicitly when user selects one
      caches: [],
      lookupLocalStorage: 'userSelectedLang',
    },
    react: {
      useSuspense: true, // Use Suspense for loading translations
    },
  });

// Sync moment locale with i18n language
const syncMomentLocale = (lng) => {
  moment.locale(lng || 'en');
};

i18n.on('languageChanged', syncMomentLocale);
i18n.on('initialized', () => syncMomentLocale(i18n.language));

export default i18n;
